
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarRoutingModule } from './sidebar-routing.module';
import { StartSidebarComponent } from './start-sidebar/start-sidebar.component';
import { MenuModule } from '../menu/menu.module';
import { AdminMenuComponent } from '../menu/admin-menu/admin-menu.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SidebarRoutingModule,
    MenuModule
  ]
})
export class SidebarModule { }
